import { useEffect } from "react"
import { RootState, useAppDispatch } from "../../../../redux/store/store"
import ItemsScheduleEmail from "../../../../components/ScheduleEmail/ItemsScheduleEmail/ItemsScheduleEmail"
import HeaderItemsScheduleEmail from "../../../../components/ScheduleEmail/HeaderItemsScheduleEmail/HeaderItemsScheduleEmail"
import { useSelector } from "react-redux"
import LoadingSpinner from "../../../../components/LoadingSpinner"
import HeaderButtonsScheduleEmail from "../../../../components/ScheduleEmail/HeaderButtonsScheduleEmail/HeaderButtonsScheduleEmail"
import { GetScheduleEmailsThunk } from "../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice"


const ScheduleEmailScreen = () => {

    const dispatch = useAppDispatch()
    const loadingContainer = useSelector((state: RootState) => state.scheduleEmailsData.loadingContainer)

    useEffect(() => {
        
        dispatch( GetScheduleEmailsThunk(1) )
    
        return () => {

        }
    }, [])
    

    return (
        <div className="flex flex-d-column">
            <HeaderButtonsScheduleEmail />
            <HeaderItemsScheduleEmail />
            <ItemsScheduleEmail />
            { loadingContainer ? <LoadingSpinner fullPage={true} /> : null }
        </div>
    )
}

export default ScheduleEmailScreen